"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrisClientState = void 0;
const NATIVE_RTC = __importStar(require("@iris/native-rtc"));
//Record the intermediate status of the client
class IrisClientState {
    constructor(globalState) {
        var _a;
        //ChannelMediaOptions
        this.publishCameraTrack = true;
        this.publishSecondaryCameraTrack = false;
        this.publishMicrophoneTrack = true;
        this.publishScreenCaptureAudio = false;
        this.publishScreenTrack = false;
        this.publishSecondaryScreenTrack = false;
        this.publishThirdScreenTrack = false;
        this.publishFourthScreenTrack = false;
        this.publishCustomAudioTrack = false;
        this.publishCustomVideoTrack = false;
        this.publishEncodedVideoTrack = false;
        this.publishMediaPlayerAudioTrack = false;
        this.publishMediaPlayerVideoTrack = false;
        this.publishTranscodedVideoTrack = false;
        this.autoSubscribeAudio = true;
        this.autoSubscribeVideo = true;
        this.enableAudioRecordingOrPlayout = false;
        this.clientRoleType = NATIVE_RTC.CLIENT_ROLE_TYPE.CLIENT_ROLE_BROADCASTER;
        this.defaultVideoStreamType = NATIVE_RTC.VIDEO_STREAM_TYPE.VIDEO_STREAM_HIGH;
        this.channelProfile = NATIVE_RTC.CHANNEL_PROFILE_TYPE.CHANNEL_PROFILE_COMMUNICATION;
        //dataStream
        this.dataStreamConfig = {
            syncWithAudio: false,
            ordered: false,
        };
        //mute 远端的用户流
        this.mutedRemoteAudioStreams = new Map();
        this.mutedRemoteVideoStreams = new Map();
        this.videoSourceType = NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA;
        //是否开启大小流
        this.enabledDualStreamMode = false;
        this.enabledDualStreamModes = new Map();
        //远端的大小流
        this.remoteVideoStreamTypes = new Map();
        //远端默认流
        this.remoteDefaultVideoStreamType = NATIVE_RTC.VIDEO_STREAM_TYPE.VIDEO_STREAM_HIGH;
        this.encryptionConfig = {
            enabled: false,
            config: new NATIVE_RTC.EncryptionConfig(),
        };
        //setPlaybackDevice: audiDevice
        this.playbackDeviceId = '';
        //setRecordingDevice: recordingDevice
        this.recordingDeviceId = '';
        // startPreviewed 似乎没有用处
        // startPreviewed: boolean = false;
        //用来记录暂停或者恢复的
        this.currChannelMediaRelayConfiguration = new NATIVE_RTC.ChannelMediaRelayConfiguration();
        this._globalState = globalState;
        if ((_a = globalState.rtcEngineContext) === null || _a === void 0 ? void 0 : _a.channelProfile) {
            this.channelProfile = globalState.rtcEngineContext.channelProfile;
        }
    }
    mergeChannelMediaOptions(options) {
        for (let key in options) {
            this[key] = options[key];
        }
        // AUDIT-v18: aliasing publishScreenCaptureVideo → publishScreenTrack
        // centralizzato. Non uso normalizeMediaOptions per evitare cycle import
        // state→util→state; inline leggibile e locale.
        if (options.publishScreenCaptureVideo !== undefined &&
            options.publishScreenTrack === undefined) {
            this.publishScreenTrack = options.publishScreenCaptureVideo;
        }
        if (this.publishCustomVideoTrack &&
            this._globalState.pushVideoFrameEnabled) {
            this.publishCameraTrack = false;
            this.publishEncodedVideoTrack = false;
            this.publishSecondaryCameraTrack = false;
            this.publishThirdCameraTrack = false;
            this.publishFourthCameraTrack = false;
            this.publishScreenTrack = false;
            this.publishSecondaryScreenTrack = false;
            this.publishThirdScreenTrack = false;
            this.publishFourthScreenTrack = false;
            this.publishMediaPlayerVideoTrack = false;
        }
    }
}
exports.IrisClientState = IrisClientState;
